import { render, staticRenderFns } from "./bookingFailDialog.vue?vue&type=template&id=6b9dada5&"
import script from "./bookingFailDialog.vue?vue&type=script&lang=js&"
export * from "./bookingFailDialog.vue?vue&type=script&lang=js&"
import style0 from "./bookingFailDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b9dada5')) {
      api.createRecord('6b9dada5', component.options)
    } else {
      api.reload('6b9dada5', component.options)
    }
    module.hot.accept("./bookingFailDialog.vue?vue&type=template&id=6b9dada5&", function () {
      api.rerender('6b9dada5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/edi/bookingFailDialog.vue"
export default component.exports